import { useState } from 'react';
import { useFetch } from '../../hooks/useFetch';
import { articleCategoriesApi } from '../../api/contentApi';
import { Button } from '../../components/ui/Button';

/** Panneau de gestion des catégories d'articles, embarqué comme onglet dans ArticlesManager. */
export function ArticleCategoriesManager() {
  const { data: categories, loading, refetch } = useFetch(() => articleCategoriesApi.list(), []);
  const [nom, setNom] = useState('');
  const [erreur, setErreur] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    setErreur('');

    try {
      await articleCategoriesApi.create(nom);
      setNom('');
      refetch();
    } catch (err) {
      setErreur(err.errors?.nom || err.message);
    } finally {
      setSubmitting(false);
    }
  }

  async function handleDelete(id) {
    if (!window.confirm('Supprimer cette catégorie ? Les articles associés resteront mais sans catégorie.')) return;
    await articleCategoriesApi.remove(id);
    refetch();
  }

  if (loading) return <p>Chargement...</p>;

  return (
    <div>
      <p className="admin-form__hint">
        Utilisées pour classer les actualités, conseils et réalisations dans le blog du site public.
      </p>

      <form className="admin-form" onSubmit={handleSubmit} style={{ maxWidth: 420 }}>
        <div className="admin-form__field">
          <label>Nouvelle catégorie</label>
          <input value={nom} onChange={(e) => setNom(e.target.value)} placeholder="Ex : Conseil" required />
          {erreur && <span className="admin-form__error">{erreur}</span>}
        </div>
        <div className="admin-form__actions">
          <Button type="submit" disabled={submitting}>
            Ajouter
          </Button>
        </div>
      </form>

      <table className="admin-table">
        <thead>
          <tr>
            <th>Nom</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {categories?.map((cat) => (
            <tr key={cat.id}>
              <td>{cat.nom}</td>
              <td className="admin-table__actions">
                <button onClick={() => handleDelete(cat.id)}>Supprimer</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {!categories?.length && <p>Aucune catégorie pour le moment.</p>}
    </div>
  );
}
